import React, {useState} from 'react'
import {
 Navigate,
 useLocation,
 useNavigate,
 useParams,
} from 'react-router-dom'
import {useAuth} from 'context/AuthProvider'
import {IFormField} from 'models/Common'
import OrderDetails from './OrderDetails'
import OrderActions from './OrderActions'
import {
 DEFAULT_TRADE_TAB,
 getTradeListPath,
 getTradeOrderPath,
 isValidTradeTab,
 TradeTabId,
} from './tradeRoutes'

type OrderDetailsLocationState = {
 actionsAllowed?: boolean
}

type OrderDetailsContentProps = {
 tabId: TradeTabId
 orderId: string
}

const OrderDetailsContent = ({
 tabId,
 orderId,
}: OrderDetailsContentProps) => {
 const navigate = useNavigate()
 const location = useLocation()
 const navigationState =
  (location.state as OrderDetailsLocationState | null) ?? {}
 const {userData} = useAuth()
 const [actionDetails, setActionDetails] =
  useState<IFormField | null>(null)
 const [, setLoader] = useState(false)

 const selectedOrder: IFormField = {
  orderId: Number(orderId),
  actionsAllowed: navigationState.actionsAllowed,
 }

 const reloadTableData = () => {
  navigate(getTradeListPath(tabId))
 }

 return (
  <div className='container relative'>
   <div className='px-[72px] pt-6 pb-[200px] bg-white'>
    <OrderActions
     loggedInUserId={userData?.userId}
     actionDetails={actionDetails}
     reloadTableData={reloadTableData}
     setActionDetails={setActionDetails}
     setLoader={setLoader}
    />
    <OrderDetails
     activeTabId={tabId}
     selectedOrder={selectedOrder}
     setSelectedOrder={() =>
      navigate(getTradeListPath(tabId))
     }
     handleActionBtnClick={setActionDetails}
    />
   </div>
  </div>
 )
}

const OrderDetailsPage = () => {
 const {tabId, orderId} = useParams<{
  tabId: string
  orderId: string
 }>()

 if (!tabId || !orderId) {
  return <Navigate to={getTradeListPath()} replace />
 }

 if (!isValidTradeTab(tabId)) {
  if (/^\d+$/.test(tabId)) {
   return (
    <Navigate
     to={getTradeOrderPath(DEFAULT_TRADE_TAB, tabId)}
     replace
    />
   )
  }

  return <Navigate to={getTradeListPath()} replace />
 }

 return (
  <OrderDetailsContent tabId={tabId} orderId={orderId} />
 )
}

export default OrderDetailsPage
